export enum EventType {
  SEND = 'SEND',
  DELIVERY = 'DELIVERY',
  BOUNCE = 'BOUNCE',
  OPEN = 'OPEN',
  CLICK = 'CLICK',
  COMPLAINT = 'COMPLAINT',
  REJECT = 'REJECT',
  DELIVERY_DELAY = 'DELIVERYDELAY',
  RENDERING_FAILURE = 'RENDERING FAILURE',
  SUBSCRIPTION = 'SUBSCRIPTION',
}
